module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAIAAABwJOjsAAAAu0lEQVR42uXPMQqDQBCF4RdTpBNxFwJikx3RxlOkSBVrr2DrETyBVdqttNqT2IleIZDKNp2QYCAHEHQQf77+zeAFwWKHw29IFnhCsMAZFgtsLN/3i6JIksS2bawWEbVtm+d5FEUAPM+TUjqOg6Wrqqqu6/8RTdMMw6CUwtIZY7TWmPo+3XXdOI5EhKWL47jv+yzLfmNqSgiBFQqCoCzLNE1d18XGsk7HeQ4Tay5cHlcWCM2dBUjfWOxv+AOBu77qYmBJ5AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/ly.png
// module id = 871
// module chunks = 0